<div *transloco="let t" class="bg-muted flex h-full min-h-0 flex-col p-5">
  <div class="flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border bg-white">
    <div class="scrollbar flex min-h-0 flex-1 flex-col items-center gap-4 p-5">
      @for (creative of creatives(); track creative.id) {
        <app-creative-preview
          [attr.data-creative-id]="creative.id"
          [creativeType]="creativeType()"
          [assets]="assets()"
          [asins]="creative.asins"
          [focused]="creative.selected"
        >
          <IBadge
            previewHeader
            color="gray"
            size="xs"
            [label]="t('creative-preview-list.creative_n', { n: creative.labelKey })"
          />
        </app-creative-preview>
      }

      <div class="mx-auto w-[80%]">
        <IAlert [title]="t('creative-preview-list.disclaimer')" />
      </div>
    </div>
  </div>
</div>
